"use strict";
import { SMask } from "../../lib/smask.js";
import { MSText } from "../text/text.js";

/**
 * @class MSTextInput
 * @extends MSText
 * @classdesc Текстовый ввод
 * */
export class MSTextInput extends MSText {
    static get observedAttributes() {
        return super.observedAttributes.concat([
            "mask",
            "isreadonly",
            "maxlength",
            "notsendbackwardconnection",
            "instantdataretrieval",
            "focushandling",
        ]);
    }

    constructor() {
        super();
        this._lockLink =
            this.getAttribute("notsendbackwardconnection") !== "false";
        this.prop_link = [];
        this.shadowRoot.innerHTML = '<input type="text"></input>';
        this.style.display = "flex";
        this.style.overflow = "hidden";
        this._text = this.shadowRoot.querySelector("input");
        this._text.style.backgroundColor = "transparent";
        this._text.style.width = "100%";
        this._text.style.height = "100%";
        this._text.style.border = "0";
        this._text.onchange = this._onChange.bind(this);

        //
        this._isreadonly = false;
        this._maxlength = 1000;
        this._text.style.justifyContent = "center"; //this.texthorizontalalign = 1;
        this._text.style.textAlign = "center";
        this._text.style.alignItems = "center"; //this.textverticalalign = 1;
        this._text.style.fontSize = 12;
        this._text.style.fontFamily = "Tahoma";
        //from proto basic
        this.textcolor = "BLACK";
        this.borderthickness = 1;
        this.backgroundcolor = "rgb(208,208,208)";
        this.focusAndClickHandler = () => {
            this.handleFocus();
        }
        this._text.addEventListener('focus', this.focusAndClickHandler) 
        this._text.addEventListener('click', this.focusAndClickHandler)
        this._text.addEventListener('keydown', this._keydownHandler)

        // при быстром вводе нужна задержка, иначе некоторые символы введутся некорректным образом
        this.inputListener = () => this.onInput(this._text.value);
        this._text.addEventListener('input', this.inputListener);
    }

    _changeRoot() {
        const cs = this._text.getAttribute("style");
        this.shadowRoot.innerHTML = "<textarea></textarea>";
        this.style.display = "flex";
        this.style.overflow = "hidden";
        this._text = this.shadowRoot.querySelector("textarea");
        this._text.setAttribute("style", cs);
        this._text.style.resize = "none";
        this._text.style.backgroundColor = "transparent";
        this._text.style.width = "100%";
        this._text.style.height = "100%";
        this._text.style.border = "0";
        this._text.onchange = this._onChange.bind(this);
        this.text = this._textValue;
        this._text.readOnly = this._isreadonly;
    }

    handleFocus() {
        if (this._maskElement) {
            this.blur();
            return;
        }

        this._initialValue = this._text.value;
        switch (+this._focushandling) {
            case 1:
                this._text.select();
                break;
            case 2:
                this._text.setSelectionRange(0, 0);
                break;
            case 3:
                this._text.setSelectionRange(this._text.value.length, this._text.value.length);
                break;
            default:
                break;
        }
    }

    _keydownHandler = (e) => {
        if (e.key === "Enter") {
            this._text.blur();
        } else if (e.key === "Escape") {
            this._text.value = this._initialValue;
            this._text.blur();
        }
    }

    get focushandling() {
        return this._focushandling;
    }

    set focushandling(value) {
        this._focushandling = value;
    }

    get notsendbackwardconnection() {
        return this._lockLink;
    }
    set notsendbackwardconnection(value) {
        this._lockLink = this._toBool(value);
    }

    get fontmultiline() {
        return this._multiline;
    }
    set fontmultiline(value) {
        this._multiline = value;
        if (!this._isChangeRoot) {
            this._isChangeRoot = true;
            if (this._toBool(value)) {
                this._changeRoot();
            }
        }
    }

    get mask() {
        return this._mask;
    }
    set mask(value) {
        if (value) {
            this._text.value = "";
            this._mask = value;
            if (value.indexOf("_") !== -1) {
                this._mask = value.replace(/_/g, "&");
            }
            this.sm = new SMask();
            this.sm.setMask(this._text, this._mask);
        } else {
            if (this.sm) {
                this.sm.delMask();
            }
            this._mask = "";
            this._text.onchange = this._onChange.bind(this);
        }
    }

    get text() {
        return typeof this._textValue !== "undefined"
            ? this._textValue
            : this.getAttribute("text");
    }
    set text(value) {
        if (value == undefined) return;
        this._textValue = value;
        if (this.sm) {
            this.sm.SetValue(value);
            if (value) this.sm._isFilling = true;
            else this.sm._isFilling = false;
        } else {
            this._text.value = value.toString().substr(0, this._maxlength);
        }
    }

    /**
     * Коллбек по изменению атрибутов элемента
     * @see https://w3c.github.io/webcomponents/spec/custom/
     * @param {string} attrName название атрибута
     * @param {*} oldVal старое значение атрибута
     * @param {*} newVal новое значение атрибута
     */
    attributeChangedCallback(attrName, oldVal, newVal, itemIndex, callbackData) {
        this.attributeChangedCallbackInternal(attrName, oldVal, newVal, callbackData, "text");
    }

    resetValueInternal() {
        if (this._rawValue != this.text) {
            this.SetParameter("text", this._rawValue, true);
        }
    }


    get isenabled() {
        return !this._text.disabled;
    }
    set isenabled(value) {
        this.disabled = !this._toBool(value);
        this._text.disabled = !this._toBool(value);
        super.isenabled = value;
    }

    get isreadonly() {
        return this._isreadonly || false;
    }
    set isreadonly(value) {
        this._isreadonly = this._toBool(value);
        this._text.readOnly = this._isreadonly;
    }

    get texthorizontalalign() {
        return this._horizontalalign;
    }

    set texthorizontalalign(value) {
        this._horizontalalign = value;
        this._text.style.textAlign = window._enums.AlignText[value];
    }

    get maxlength() {
        return this._maxlength;
    }
    set maxlength(value) {
        this._maxlength = value;
        this._text.maxLength = value;
    }

    // Мгновенное получение значений
    get instantdataretrieval() {
        return this._instantdataretrieval ?? false;
    }
    set instantdataretrieval(value) {
        this._instantdataretrieval = this._toBool(value);
    }

    _onChange(e) {
        e.preventDefault();
        if (this._isreadonly) {
            return;
        }
        this.updateValue(e.target.value);
    }

    onInput(value) {
        if (this.instantdataretrieval && !this._isreadonly) {
            this.updateValue(value);
        }
    }

    updateValue(value) {
        if(value === undefined || value === null) value = "";
        if(value !== 'string') value = String(value);
        const ml = value.split("\n");
        for (let i = 0; i < ml.length; i++) {
            ml[i] = ml[i].replace(/\s+/g, " ");
        }
        const newText = this.sm ? this.sm.value : ml.join("\n");
        const old = this._text.getAttribute("value");
        if (old != newText) {
            this.SetParameter("text", newText, false, null, null, "", {
                forced: true,
            });
        }
    }

    disconnectedCallback() {
        this._text.removeEventListener('input', this.inputListener);
        this._text.removeEventListener('focus', this.focusAndClickHandler);
        this._text.removeEventListener('click', this.focusAndClickHandler);
        this._text.removeEventListener('keydown', this._keydownHandler);
        this._text.remove();
        this._text.onchange = null;
        delete this._text;
        this.shadowRoot.innerHTML = "";
        super.disconnectedCallback();
    }
}
